import { createPinia } from 'pinia';
import persistedState from 'pinia-plugin-persistedstate';
const store = createPinia();
store.use(persistedState);
export { store };
export * from './modules';
